// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1dCqu","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2V8mk"};